import app from '@/common/public';
import { refConfig } from '@/common/config/refConfig.js';
//超时时间的值
const timeOutValue = 120000;
/**
 * 请求封装，目前内容适配老的请求格式和方式
 * 可通过promise/ async await 模式调用
 * @param {apiName} api定义内容  method 不填默认为Post
 * @param {params} 请求参数
 * @param {config} 配置参数
 * @returns
 */
function api({ apiName, params = {}, config = {} }) {
  return new Promise((resolve, reject) => {
    // TODO 暂时做中间层使用原有api，后续重写api逻辑
    app.request(
      apiName,
      params,
      (res) => {
        resolve(res);
      },
      (res) => {
        reject(res);
      },
      config.notHideLoading || false,
      config.notFilteringParam || false,
      config.needAbort || false,
    );
  });
}

/**
 * 请求封装
 * 可通过promise/ async await 模式调用
 * @param {apiName} api定义内容  method 不填默认为Post
 * @param {params} 请求参数
 * @param {config} 配置参数   notNeedAbort 接口请求是否要中端
 * @returns
 */
function request({ apiName, params = {}, config = {} }) {
  return new Promise((resolve, reject) => {



    let settings = app.GetSettings();
    let contentType = 'application/json';
    let userInfo = settings.MemberInfo;
    let flag = false;
    let ikey = settings.EnterpriseKey || '';
    let requesturl = app.getLoadBalancingApiUrl(apiName.module, apiName.address, ikey);
    let sessionId = getSessionId();
    let requestId = app.getUUId();

    let requestParamTemp = setRequestRecord({
      url: requesturl,
      requestParam: params,
      config: config,
    });

    let headerParam = setBasisParam(params, settings);
    params = {
      ...params,
      ...headerParam,
    };

    let headerPlatId = app.getHeaderPlatId(settings.platId, app.plantId, app.MemberInfo.PlatId);

    if (app.isNoNet && !app.isInNoNetPage) {
      uni.navigateTo({
        url: '/components/netError',
      });
      isInNoNetPage = true;
      app.HideLoading();
      return;
    }

    let requestTask = uni.request({
      url: requesturl,
      data: params,
      method: apiName.method || 'post',
      header: {
        ...headerParam,
        'Content-Type': contentType,
        sessionId: sessionId,
        reqId: requestId,
        ikey: ikey,
      },
      success: (res) => {
        res.data.code = res.data.code || res.data.Code;
        if (res.data.code == '8001' || res.data.code == '8000') {
          app.setCustomerNull();
          if (!app.isWXOrDD()) {
            uni.navigateTo({
              url: '/pages/loginAndRegister/login/login',
            });
          }
          app.HideLoading();
        }
        if (app.GetResultState(res.data)) {
          resolve(res.data);
        } else {
          reject(res.data);
        }
      },
      fail: (e) => {
        reject(e);
      },
      complete: (res) => {

        app.requestCompleteCallback(res, apiName, params, apiName.method);

        app.deletePostParam(requestParamTemp);
      },
    });

    requestParamTemp.requestTask = requestTask;
    app.apiRequestList.push(requestParamTemp);

    // 设置超时处理
    // setTimeout(() => {
    //   requestTask.abort();
    //   app.deletePostParam(requestParamTemp);
    //   app.Toast('网络请求超时');
    // }, timeOutValue);
  });
}

//设置请求记录
function setRequestRecord({ url, requestParam = {}, config = {} }) {
  let temp = {
    requesturl: url,
    param: JSON.stringify(requestParam),
    needAbort: !config.notNeedAbort,
  };

  app.checkPostParam(temp);
  return temp;
}

function getSessionId() {
  let sessionId = '';
  let globalData = getApp().globalData;
  if (globalData) {
    if (globalData.sessionId) {
      sessionId = globalData.sessionId;
    } else {
      sessionId = app.getUUId();
      globalData.sessionId = sessionId;
    }
  }

  return sessionId;
}

//设置基础请求参数
function setBasisParam(requestParam, settings) {
  let headerParam = {};
  if (!requestParam.MemberId && !requestParam.Token) {
    if (settings.MemberInfo && settings.MemberInfo.MemberId) {
      headerParam.MemberId = settings.MemberInfo.MemberId || '';
      headerParam.Token = settings.MemberInfo.Token || '';
    }
  }

  if (!requestParam.PlatId) {
    if (settings.platId) {
      headerParam.PlatId = settings.platId;
    } else {
      headerParam.PlatId = app.plantId || app.MemberInfo.PlatId;
    }
  } else {
    headerParam.PlatId = headerParam.platId;
  }

  if (!requestParam.RefId) {
    if (settings.RefId) {
      headerParam.RefId = settings.RefId;
    } else {
      headerParam.RefId = app.refId || '0';
    }
  } else {
    headerParam.RefId = requestParam.RefId;
  }

  // 如果外面穿传值就不传了
  if (!requestParam.IsTravelBussiness && requestParam.IsTravelBussiness !== 0) {
    requestParam.IsTravelBussiness = settings.bookingMethod != 0 ? 1 : 0;
  }
  if (settings.RefId == refConfig.dingdingjijian) {
    requestParam.IsTravelBussiness = 0;
  }

  headerParam.Version = app.MemberInfo.Version;
  requestParam.MemberMac = settings.MemberMac;
  requestParam.PhoneType = settings.PhoneType;

  return headerParam;
}

function getRequestMethod(method) {
  return method ? method.toString().toLowerCase() : 'post';
}
export { api, request };
